<template>
  <div>
    <md-card class="friends-card" @click.native="navigateToFriend($event)" :class="{ 'clickable': isClickable }">
      <pagination-trigger
        v-if="enableTrigger"
        @triggerIntersected="paginateAllFriends"
      />
      <avatar-with-level-info :user="friend"/>
      <md-button
        v-if="showDisconnectButton"
        class="md-simple disconnect"
        @click="disconnect"
      >
        {{ $t('friends.disconnect').toUpperCase() }}
      </md-button>

      <md-button
        v-if="showAcceptFriendButton"
        class="md-danger"
        @click="accept"
      >
        {{ $t('general.accept').toUpperCase() }}
      </md-button>

      <md-button
        v-if="showAcceptFriendButton"
        class="md-rose md-simple"
        @click="decline"
      >
        {{ $t('general.decline').toUpperCase() }}
      </md-button>

      <md-button
        v-if="showCancelInviteButton"
        class="md-simple disconnect"
        @click="cancel"
      >
        {{ $t('general.cancel').toUpperCase() }}
      </md-button>

      <md-button
        v-if="showAddAFriendButton"
        class="md-danger"
        @click="addFriend"
      >
        {{ $t('friends.inviteFriend').toUpperCase() }}
      </md-button>
      <md-button
        v-if="showResentFriendInvitationButton"
        class="md-danger"
        @click="resendFriendInvitation"
      >
        {{ $t('friends.reInvite').toUpperCase() }}
      </md-button>
      <md-button
          v-if="showEditButton"
          class="md-block md-success"
          @click="navigateToEdit"
      >
        {{ $t('general.edit').toUpperCase() }}
      </md-button>
    </md-card>
  </div>
</template>

<script>
import AvatarWithLevelInfo from '../atoms/avatar-with-level-info';
import PaginationTrigger from '../atoms/pagination-trigger';
export default {
  name: 'FriendCard',
  components: { AvatarWithLevelInfo, PaginationTrigger },
  props: {
    enableTrigger: {
      type: Boolean
    },
    stopIntersecting: {
      type: Boolean
    },
    friend: {
      type: Object,
      required: true,
    },
    showDisconnectButton: {
      type: Boolean
    },
    showAcceptFriendButton: {
      type: Boolean
    },
    showCancelInviteButton: {
      type: Boolean
    },
    showAddAFriendButton: {
      type: Boolean
    },
    showResentFriendInvitationButton: {
      type: Boolean
    },
    showEditButton: {
      type: Boolean
    },
    isClickable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    disconnect() {
      this.$emit('removeFriend', this.friend._id);
    },
    addFriend() {
      this.$emit('onAddFriend', this.friend._id);
    },
    accept() {
      this.$emit('acceptFriendRequest', this.friend._id);
    },
    decline() {
      this.$emit('declineFriendRequest', this.friend._id);
    },
    cancel() {
      this.$emit('cancelFriendRequest', this.friend._id);
    },
    resendFriendInvitation() {
      this.$emit('resendFriendInvitation', this.friend._id);
    },
    navigateToEdit() {
      this.$emit('navigateToEdit', this.friend._id);
    },
    paginateAllFriends() {
      setTimeout(() => {
        if (!this.stopIntersecting) {
          this.$emit('paginateAllFriends');
        }
      })
    },
    navigateToFriend() {
      this.$emit('navigateToFriend', this.friend._id)
    }
  }
}
</script>

<style lang="scss">
.friends-card {
  padding: 15px;
  letter-spacing: 1px;
  .md-button {
    margin-top: 16px;
    .md-button-content {
      font-size: 14px;
      font-weight: 500;
    }
    &.disconnect {
      border: 1px solid #005FB6;
      .md-button-content {
        color: #005FB6;
      }
    }
  }
}
</style>